import { type Component } from "vue";
import { type RouteRecordRaw } from "vue-router";
import { Role } from "core-fe-lib/openapi/core/models/Role";

export function creditRoutes(MainLayout: Component): RouteRecordRaw {
  return {
    path: "/credit",
    component: MainLayout,
    children: [
      {
        path: "",
        component: () =>
          import("core-fe-lib/components-shadcn/layouts/PassthroughLayout.vue"),
        children: [
          {
            path: "balances",
            name: "credit-balances",
            component: () =>
              import("./pages/balances/BalanceList.vue"),
            meta: { requiresAuth: true, requiredPrivilege: Role.ADMIN },
          },
          {
            path: "balances/edit",
            name: "credit-balance-edit",
            component: () =>
              import("./pages/balances/BalanceEdit.vue"),
            meta: { requiresAuth: true, requiredPrivilege: Role.ADMIN },
          },
          {
            path: "transactions",
            name: "credit-transactions",
            component: () =>
              import("./pages/transactions/TransactionList.vue"),
            meta: { requiresAuth: true, requiredPrivilege: Role.ADMIN },
          },
          // Superadmin plan-catalog editor (ADR 024)
          {
            path: "plans",
            name: "credit-plans",
            component: () =>
              import("./pages/plans/PlanCatalogPage.vue"),
            meta: { requiresAuth: true, requiredPrivilege: Role.SUPER_ADMIN },
          },
          // Buy-credits flow (any authenticated user)
          {
            path: "buy",
            name: "credit-buy",
            component: () =>
              import("./pages/buy/BuyCredits.vue"),
            meta: { requiresAuth: true },
          },
          {
            path: "buy/return",
            name: "credit-buy-return",
            component: () => import("./pages/buy/BuyReturn.vue"),
            meta: { requiresAuth: true },
          },
          // Post-3DS return for a paid subscription upgrade (ADR 024)
          {
            path: "subscription/return",
            name: "credit-subscription-return",
            component: () =>
              import("./pages/subscription/SubscriptionReturn.vue"),
            meta: { requiresAuth: true },
          },
          // Self-serve topup history
          {
            path: "me/topups",
            name: "credit-me-topups",
            component: () =>
              import("./pages/topups/MyTopupList.vue"),
            meta: { requiresAuth: true },
          },
          // Admin-only topup history (incl. refund button)
          {
            path: "topups",
            name: "credit-topups",
            component: () =>
              import("./pages/topups/AdminTopupList.vue"),
            meta: { requiresAuth: true, requiredPrivilege: Role.ADMIN },
          },
        ],
      },
    ],
  };
}
